howspace.components.toggleButton = (() => {
    'use strict';

    const handleChange = (e) => {
        const checkbox = $(e.target);
        if (checkbox.prop('checked')) {
            checkbox.attr('aria-checked', 'true');
            checkbox.attr('checked', '');
        } else {
            checkbox.attr('aria-checked', 'false');
            checkbox.removeAttr('checked');
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === ' ' && e.target.classList.contains('icon')) {
            // Focus is in the tooltip and user hit space. Toggle the checkbox.
            e.preventDefault();
            $(e.target).closest('.howspace-form-toggle-button').find('input[type="checkbox"]').trigger('click');
        }
    };

    return {
        init : (elem) => {
            elem.findIncludingSelf('.howspace-form-toggle-button:not(.howspace-form-toggle-button-initialized)')
                .each(function() {
                    const toggleButton = $(this);
                    toggleButton.addClass('howspace-form-toggle-button-initialized');
                    toggleButton.on('change', handleChange);
                    toggleButton.on('keydown', handleKeyDown);
                }
            );
        },
        destroy : (elem) => {
            elem.findIncludingSelf('.howspace-form-toggle-button.howspace-form-toggle-button-initialized')
                .each(function() {
                    const toggleButton = $(this);
                    toggleButton.removeClass('howspace-form-toggle-button-initialized');
                    toggleButton.off('change', handleChange);
                    toggleButton.off('keydown', handleKeyDown);
                }
            );
        }
    };

})();
